import React from 'react';
import './css/SearchResultCard.css';
import { DEFAULT_USER_AVATAR } from '../../shared/constants/common';
import { isUserLoggedIn, getUserRole } from '../../shared/utils/function';
import { ROLE } from '../../shared/constants/common';
import { useNavigation } from '../../shared/utils/useNavigation';
import { fireAndForgetAddCreatorCategories } from '../../shared/actions/contentAction';
import LazyImage from '../../components/LazyImage';
import { getCreatorListSubtitle } from '../../shared/utils/paymentUtil';

const SearchResultCard = ({
  noImage,
  noSubLine,
  creator,
  vatPercentage = 0,
  avatarClassName = '',
  showIcon = true,
  onClick = null
}) => {
  const isLoggedIn = isUserLoggedIn();
  const userRole = getUserRole();
  const navigate = useNavigation();
  const displayUsername = `@${creator.username}`;
  const subtitle = getCreatorListSubtitle(creator, vatPercentage);

  // Handle creator click
  const handleCreatorClick = () => {
    // Add creator categories to user's category list (fire-and-forget)
    if (isLoggedIn && userRole === ROLE.USER && creator && typeof creator === 'object') {
      fireAndForgetAddCreatorCategories(creator);
    }

    // Call optional onClick callback (e.g., to save to recent searches)
    if (onClick && typeof onClick === 'function') {
      onClick(creator);
    }

    navigate.toProfile(creator.username);
  };

  // Format follower count
  // const formatFollowerCount = (count) => {
  //   if (!count) return '0 Followers';
  //   if (count < 1000) return `${count} Followers`;
  //   if (count < 1000000) return `${(count / 1000).toFixed(1)}k Followers`;
  //   return `${(count / 1000000).toFixed(1)}M Followers`;
  // };

  return (
    <div
      className={`jh-search-result-item ${noSubLine ? 'cm_noSubLine' : ''} ${noImage ? 'noImage' : ''}`}
      onClick={handleCreatorClick}
    >
      {noImage ? '' : (
        <LazyImage
          src={creator.profile_picture}
          alt={displayUsername}
          className={`jh-search-result-avatar ${avatarClassName}`}
          onError={(e) => {
            e.target.src = DEFAULT_USER_AVATAR;
          }}
        />
      )}

      <div className="jh-search-result-info">
        <p className="jh-search-result-username">
          {displayUsername} 
          {showIcon && creator.isTrending && (
            <span className="jh-search-result-trending-badge ml-1">
             <i className="fas fa-fire jh-search-section-icon jh-trending-icon"></i>
            </span>
          )}
          {showIcon && creator.isFeature && (
            <span className="jh-search-result-feature-badge ml-1">
              <i className="fas fa-star jh-search-section-icon jh-featured-icon"></i>
            </span>
          )}
        </p>
        {subtitle && (
          <p className="jh-search-result-price">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default SearchResultCard;

